const CAMPAIGN_WEBSERVICE_ID = 197

export const campaignProcedureUrl = (procedureName: string) =>
  `/webservice/${CAMPAIGN_WEBSERVICE_ID}/sp/v4/${procedureName}/call`

// Campaigns
export const SP_LUT_CAMPAIGN_LIST_GET_BY_ISR = 'spLutCampaignListGetByISR'
export const SP_LUT_CAMPAIGN_LIST_GET_BY_OWNER = 'spLutCampaignListGetByOwner'
export const SP_LUT_CAMPAIGN_CREATE = 'spLutCampaignCreate'
export const SP_LUT_CAMPAIGN_COPY = 'spLutCampaignCopy'
export const SP_LUT_CAMPAIGN_UPDATE = 'spLutCampaignUpdate'
export const SP_LUT_CAMPAIGN_DELETE = 'spLutCampaignDelete'

// Objectives
export const SP_LUT_CAMPAIGN_OBJECTIVES_GET = 'spLutCampaignObjectivesGet'
export const SP_LUT_CAMPAIGN_OBJECTIVES_CREATE = 'spLutCampaignObjectivesCreate'
export const SP_LUT_CAMPAIGN_OBJECTIVES_UPDATE = 'spLutCampaignObjectivesUpdate'
export const SP_LUT_CAMPAIGN_OBJECTIVES_DELETE = 'spLutCampaignObjectivesDelete'

// Calling lists
export const SP_LUT_CAMPAIGN_CALLING_LIST_GET_EXTENDED = 'spLutCampaignCallingListGetExtended'
export const SP_LUT_CALLING_LIST_CREATE_FROM_FILE = 'spLutCallingListCreateFromFile'
export const SP_LUT_CALLING_LIST_UPDATE = 'spLutCallingListUpdate'
export const SP_LUT_CALLING_LIST_RECORD_DELETE = 'spLutCallingListRecordDelete'
export const SP_LUT_CAMPAIGN_CALLING_LIST_DELETE = 'spLutCampaignCallingListDelete'

// Call outcomes
export const SP_LUT_CAMPAIGN_CALL_OUTCOMES_GET = 'spLutCampaignCallOutcomesGet'
export const SP_LUT_CAMPAIGN_CALL_OUTCOMES_CREATE = 'spLutCampaignCallOutcomesCreate'
export const SP_LUT_CAMPAIGN_CALL_OUTCOMES_UPDATE = 'spLutCampaignCallOutcomesUpdate'

// Ratings
export const SP_LUT_CALCULATE_ALL_ISR_RATINGS = 'spLutCalculateAllISRRatings'

// Documents and links
export const SP_LUT_CAMPAIGN_DOCUMENTS_GET_BY_COMPANY = 'spLutCampaignDocumentsGetByCompany'
export const SP_LUT_CAMPAIGN_LINKS_GET_BY_COMPANY = 'spLutCampaignLinksGetByCompany'
export const SP_LUT_CAMPAIGN_LINKS_CREATE = 'spLutCampaignLinksCreate'
export const SP_LUT_CAMPAIGN_LINKS_UPDATE = 'spLutCampaignLinksUpdate'
export const SP_LUT_CAMPAIGN_LINKS_DELETE = 'spLutCampaignLinksDelete'
